<template>
    <div class="cell-cover">
        <div class="cell h-100 w-100" @click="cubeClick">
            <div class="cell-item-cover d-flex flex-row" v-if="hasInit">
                <div class="cell-item h-100 cl-orange"
                     v-for="(item,index) in values"
                     :key="item.id"
                     :style="styleStr(rateArray[index].offset, rateArray[index].value)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ManLoadsCube",
    props: {
        cubeData: {}
    },
    computed: {
        values() {
            if (this.cubeData === undefined) {
                return [];
            }
            let temp = this.cubeData.values;
            return temp.reverse();
        }
    },
    data() {
        return {
            rateArray: [],
            length: 864000,
            hasInit: false
        }
    },
    mounted() {
        this.initRateArray();
    },
    methods: {
        initRateArray() {
            console.log('update')
            let valTemp = [];
            let preTime = null;
            for (let item of this.values) {
                valTemp.push({
                    offset: this.calDayTimeOffsetRate(preTime, item.fromTime, true),
                    value: this.calDayTimeOffsetRate(item.fromTime, item.toTime, true)
                });
                preTime = item.toTime;
            }
            this.rateArray = valTemp;
            this.hasInit = true;
        },
        styleStr(ml, w) {
            return 'margin-left:' + ml + '%; width:' + w + '%; '
        },
        calDayTimeOffsetRate(f, t, inner) {
            if (f == null) {
                f = this.cubeData.dateStr + ' 00:00:00';
            }
            return this.calTimeBetween(f, t) / (inner ? this.length : 864000);
        },
        calTimeBetween(f, t) {
            return new Date(t).getTime() - new Date(f).getTime();
        },
        cubeClick() {
            this.$store.commit('manLoad/setCubeValues', this.values);
            this.$emit('cubeClick');
        }
    }
}
</script>

<style scoped>
.cell-cover {
    height: 30px;
    width: 60px;
}

.cell {
    border-radius: 5px;
    overflow: auto;
    margin: 0 auto 0 0;
    background-color: #f5f5f5;
    transition: .2s ease-out;
}

.cell:hover {
    box-shadow: 0 0 0 .2rem rgba(255, 165, 0, .7);
    opacity: 1 !important;
}

.cell-item-cover {
    height: 100%;
    width: 100%;
    overflow: hidden;
    max-width: 60px;
    animation: ani-width .3s linear;
}

@keyframes ani-width {
    from {
        max-width: 0;
    }
}

.cell-active {
    box-shadow: 0 0 0 .15rem rgba(255, 165, 0, .4)
}

.cell-opacity {
    opacity: 0.6;
}

.cell-item {
}
</style>